import React from "react";
import cx from "classnames";
import { Trans } from "@elevio/kb-kit/lib/components/trans";
import LoginLogout from "./LoginLogout";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faTwitter, faVimeo } from '@fortawesome/free-brands-svg-icons';
const BEVERLY_CONTACT_US = 'https://apps.beverlyhills.org/citymanager/connectwithcityhall/';
function Footer({ className }) {
    return (<footer className={cx("footer", className)} data-testid="footer">
      <div className="footer-wrapper">
        <p className="footer-copyright">
          &copy; {new Date().getFullYear()} Comcate, Inc.
        </p>
        <nav className="footer-nav">
          <a className="footer-link" target="_blank" href={BEVERLY_CONTACT_US}>
            <Trans>Contact Us</Trans>
          </a>
          <a className="footer-link" target="_blank" role="img" href="https://www.facebook.com/CityofBevHills" aria-label="facebook-link">
            <FontAwesomeIcon icon={faFacebookF}/>
          </a>
          <a className="footer-link" target="_blank" role="img" href="https://twitter.com/CityofBevHills" aria-label="twitter-link">
            <FontAwesomeIcon icon={faTwitter}/>
          </a>
          <a className="footer-link" target="_blank" role="img" href="https://vimeo.com/beverlyhillstv" aria-label="vimeo-link">
            <FontAwesomeIcon icon={faVimeo}/>
          </a>
          <LoginLogout className="footer-link"/>
        </nav>
      </div>
    </footer>);
}
export default Footer;
